<template v-if="proposal">
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <material-card color="cyan" title="Dados da Proposta" text="">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 text-xs-right>
                <cpn-lead-upload></cpn-lead-upload>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  ref="proposal_name"
                  :rules="notEmptyRule"
                  v-model="proposal.name"
                  name="name"
                  label="*Nome Completo"
                  prepend-icon="person"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="proposal.postal_code"
                  name="postal_code"
                  label="*CEP"
                  prepend-icon="address"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="proposal.address"
                  name="address"
                  label="*Endereço Completo"
                  prepend-icon="address"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="proposal.district"
                  name="district"
                  label="*Bairro"
                  prepend-icon="district"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="proposal.city"
                  name="city"
                  label="*Cidade"
                  prepend-icon="city"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-autocomplete
                  :items="states"
                  item-text="name"
                  item-value="initials"
                  label="Estado"
                  prepend-icon="map"
                  v-model.lazy="proposal.state"
                  return-object
                  :rules="[(v) => !!v || 'Por favor, selecione o seu estado!']"
                  :hint="'Selecione o estado'"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="proposal.cpf"
                  :rules="notEmptyRule"
                  name="cpf"
                  label="*CPF/CNPJ"
                  return-masked-value
                  :v-mask="['###.###.###-##', '##.###.###/####-##']"
                  prepend-icon="phone"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="proposal.consumer_unit"
                  label="Unidade Consumidora"
                  :rules="notEmptyRule"
                  prepend-icon="record_voice_over"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  id="installation_number"
                  :rules="notEmptyRule"
                  v-model="proposal.installation_number"
                  label="Numero de Instalação"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  id="classe"
                  v-model="proposal.classe"
                  :rules="notEmptyRule"
                  label="Classe"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  id="subclasse"
                  v-model="proposal.subclasse"
                  :rules="notEmptyRule"
                  label="Sub Classe"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  id="tarifa"
                  v-model.number="proposal.tarifa"
                  label="Tarifa Base"
                  type="number"
                  :rules="notEmptyRule"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                Histórico
                <table>
                  <tr>
                    <th>Mes/Ano</th>
                    <th>Consumo</th>
                    <th>Dias</th>
                  </tr>
                  <tr v-for="(history, index) in proposal.history" :key="index">
                    <td>
                      <v-text-field
                        :id="`history_mes_${index}`"
                        v-model="history.mes_ano"
                        required
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        :id="`history_consumo_${index}`"
                        v-model.number="history.consumo"
                        type="number"
                        required
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        :id="`history_dias_${index}`"
                        v-model.number="history.dias"
                        required
                        type="number"
                      ></v-text-field>
                    </td>
                  </tr>
                </table>
              </v-flex>
              <v-flex xs12 md6>
                <v-layout wrap>
                  <v-flex xs12 md2>
                    <v-text-field
                      id="discount"
                      :rules="notEmptyRule"
                      type="number"
                      v-model.number="proposal.discount"
                      label="% de Desconto"
                      value="15"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      :items="power_plants"
                      item-text="name"
                      item-value="power_plant_id"
                      prepend-icon="flash_on"
                      label="Planta"
                      return-object
                      :value="proposal.power_plant_id"
                      v-model="proposal.power_plant"
                      :rules="[
                        (v) =>
                          !!v || 'Selecione a Planta que o Lead irá entrar',
                      ]"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-btn
                      color="primary"
                      rounded
                      small
                      @click.prevent="calcproposal(lead, proposal)"
                    >
                      <!-- <v-icon left dark>flash</v-icon> -->
                      Calcular Proposta
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field
                      id="average"
                      type="number"
                      v-model.number="proposal.average"
                      label="Média de Consumo"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1> - </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field
                      id="desvio_padrao"
                      type="number"
                      v-model.number="proposal.desvio_padrao"
                      label="Desvio Padrão"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1> - </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field
                      id="custo_disp"
                      type="number"
                      v-model.number="proposal.custo_disp"
                      label="Custo de Disponibildiade"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md1> = </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      id="creditos"
                      v-model.number="proposal.creditos"
                      type="number"
                      label="Média de Créditos"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      id="mensalidade"
                      v-model.number="proposal.mensalidade"
                      type="number"
                      label="Mensalidade Média"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      v-model.number="proposal.economia_mensal"
                      type="number"
                      label="Economia Mensal"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      id="anual"
                      v-model.number="proposal.economia_anual"
                      label="Economia Anual"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      id="contrato"
                      v-model.number="proposal.economia_contrato"
                      label="Economia Contrato"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      id="percentual_planta"
                      v-model.number="proposal.percentual_planta"
                      label="Percentual de Aluguel"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn
                  class="mx-0 font-weight-light"
                  color="success"
                  :loading="loading"
                  :disabled="!valid || loading"
                  @click.prevent="storeproposal(lead, proposal)"
                >
                  <v-icon left dark>add</v-icon>
                  Salvar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </material-card>
    </v-layout>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-container>
</template>
<script>
import statesfile from "@/model/state";
import { eventBus } from "../../main";
import { GET_POWERPLANTCOMBO } from "../../graphql/powerplants";
import LeadUpload from "./LeadUpload";
// import { updateLead } from '../../services/leads'
import {
  UPDATE_LEAD,
  ProposalHistoryMutableFragment,
} from "../../graphql/leads";
import { filter } from "graphql-anywhere";
import { mask } from "vue-the-mask";
export default {
  data: function () {
    return {
      emailRules: [],
      lead: {},
      rules: [],
      states: statesfile.estados,
      proposal: {},
      power_plants: [],
      power_plant: {},
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
      loading: false,
      consumer_unit_sel: "",
      type: "new",
      valid: false,
      notEmptyRule: [(v) => !!v || "Por favor, esse dado é obrigatório."],
    };
  },
  directives: { mask },
  components: {
    cpnLeadUpload: LeadUpload,
  },
  created() {
    eventBus.$on("leadSelected", (lead) => {
      this.lead = lead;
    });
    eventBus.$on("proposal", (proposal) => {
      this.proposal = proposal.data;
      this.consumer_unit_sel = proposal.consumer_unit;
      this.type = proposal.type;
      if (proposal.type !== "calc")
        if (this.$refs["proposal_name"]) this.$refs["proposal_name"].focus();
    });
  },
  methods: {
    calcproposal(lead, proposal) {
      const average = this.average(proposal.history);
      const desvio_padrao = this.standardDeviation(proposal.history);
      const custo_disp = this.calcCustoDisp(proposal.classe);
      const creditos = average - custo_disp - desvio_padrao;
      const tarifa = proposal.tarifa;
      const mensalidade = creditos * tarifa;
      const discount = proposal.discount / 100;
      proposal.average = parseFloat(average.toFixed(2));
      proposal.custo_disp = parseFloat(custo_disp.toFixed(2));
      proposal.desvio_padrao = parseFloat(desvio_padrao.toFixed(2));
      proposal.creditos = parseFloat(creditos.toFixed(2));
      proposal.mensalidade = parseFloat(mensalidade.toFixed(2));
      proposal.economia_mensal = (mensalidade * discount).toFixed(2);
      proposal.economia_anual = (mensalidade * discount * 12).toFixed(2);
      proposal.economia_contrato = (mensalidade * discount * 36).toFixed(2);
      proposal.percentual_planta = (
        (creditos / proposal.power_plant.power_monthly) *
        100
      ).toFixed(2);
      this.proposal = proposal;
    },
    storeproposal(lead, proposal) {
      if (this.$refs.form.validate()) {
        let newLeadProposal = {
          name: proposal.name,
          postal_code: proposal.postal_code,
          address: proposal.address,
          district: proposal.district,
          city: proposal.city,
          state: {
            initials: proposal.state.initials,
            name: proposal.state.name || "",
          },
          cpf: proposal.cpf,
          consumer_unit: proposal.consumer_unit,
          installation_number: proposal.installation_number,
          classe: proposal.classe,
          subclasse: proposal.subclasse,
          tarifa: proposal.tarifa * 1,
          history: filter(ProposalHistoryMutableFragment, proposal.history),
          discount: proposal.discount * 1 || 0,
          power_plant_id: proposal.power_plant.power_plant_id || "",
          average: proposal.average * 1 || 0,
          desvio_padrao: proposal.desvio_padrao * 1 || 0,
          custo_disp: proposal.custo_disp * 1 || 0,
          creditos: proposal.creditos * 1 || 0,
          mensalidade: proposal.mensalidade * 1 || 0,
          economia_mensal: proposal.economia_mensal * 1 || 0,
          economia_anual: proposal.economia_anual * 1 || 0,
          economia_contrato: proposal.economia_contrato * 1 || 0,
          percentual_planta: proposal.percentual_planta * 1 || 0,
        };
        this.loading = true;
        if (!lead.email || lead.email === "undefined") {
          this.show_snack("Erro: Lead não selecionado", "error", "top");
          this.loading = false;
          return;
        }

        proposal.discount = Number(proposal.discount);
        if (lead.proposals) {
          if (this.type === "edit" && this.consumer_unit_sel !== "") {
            // const proposal_sel = this.consumer_unit_sel
            lead.proposals.forEach((newproposal, index) => {
              if (newproposal.consumer_unit === newLeadProposal.consumer_unit) {
                lead.proposals[index] = newLeadProposal;
              }
            });
          } else {
            lead.proposals.unshift(newLeadProposal);
          }
        } else {
          lead.proposals = [];
          lead.proposals.push(newLeadProposal);
        }
        this.$apollo
          .mutate({
            // Query
            mutation: UPDATE_LEAD,
            // Parameters
            variables: {
              id: lead.email,
              email: lead.email,
              name: lead.name,
              cpf: lead.cpf,
              // phone: lead.phone,
              // average_consumption: lead.average_consumption,
              step: 2,
              // promo_code: lead.promo_code,
              // state: newState,
              proposals: lead.proposals,
            },
          })
          .then(() => {
            this.loading = false;
            if (this.type === "edit") {
              this.show_snack(
                "Proposta atualizados com sucesso!",
                "success",
                "top",
              );
              this.loading = false;
            } else {
              this.show_snack(
                "Proposta adicionada com sucesso!",
                "success",
                "top",
              );
              this.loading = false;
            }
            this.lead = lead;
          })
          .catch((error) => {
            this.loading = false;
            this.show_snack(
              "Erro ao gravar lead. " + error.message,
              "error",
              "top",
            );
          });
      }
    },
    calcCustoDisp(classe) {
      switch (classe) {
        case "Monofásico":
          return 30;
        case "Bifásico":
          return 50;
        case "Trifásico":
          return 100;
        default:
          return 50;
      }
    },
    standardDeviation(values) {
      var avg = this.average(values);
      var diff = 0;
      var sqrDiff = 0;
      var squareDiffs = values.map(function (value) {
        var consumo = value.consumo * 1;

        if (consumo > 0) {
          diff = consumo - avg;
          sqrDiff = diff * diff;
        }
        return sqrDiff;
      });
      var avgSquareDiff = this.average(squareDiffs);
      var stdDev = Math.sqrt(avgSquareDiff);
      return stdDev;
    },

    average(data) {
      var sum = data.reduce(function (sum, value) {
        if (value.consumo) {
          return sum + value.consumo;
        } else {
          return sum + value;
        }
      }, 0);

      var avg = sum / data.length;
      return avg;
    },
    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
  },
  computed: {
    filteredPowerPlants() {
      if (this.user && this.user.group && this.user.group === "admin")
        return this.power_plants;

      var PowerPlantArray = [];
      this.power_plants.filter((power_plant) => {
        return this.user.power_plants.filter((power_plant2) => {
          if (power_plant2.id === power_plant.PowerPlantId) {
            PowerPlantArray.push(power_plant);
          }
        });
      });
      return PowerPlantArray;
    },
  },
  apollo: {
    powerplants: {
      query: GET_POWERPLANTCOMBO,
      // Optional result hook
      result({ data, loading }) {
        this.power_plants = data.powerplants;
        this.loading = loading;
      },
      // Error handling
      error(error) {
        console.error("We've got an error!", error);
      },
    },
  },
};
</script>
